import { render, staticRenderFns } from "./OrdersAvatarCell.vue?vue&type=template&id=267e2d74&scoped=true&"
import script from "./OrdersAvatarCell.vue?vue&type=script&lang=ts&"
export * from "./OrdersAvatarCell.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersAvatarCell.vue?vue&type=style&index=0&id=267e2d74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e2d74",
  null
  
)

export default component.exports